import { makeStyles } from '@mui/styles';

export const useSearchResultsStyles = makeStyles((theme) => ({
  section: {
    marginBottom: '8px'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    padding: '12px 12px 4px 12px'
  },
  sectionTitle: {
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: theme.palette.text.secondary
  },
  sectionCount: {
    color: theme.palette.text.secondary
  },
  showMore: {
    margin: '4px 0 4px 8px'
  }
}));
